var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { PaginationItem } from "../../components";
let SuperBannerPagination = class SuperBannerPagination extends React.PureComponent {
    render() {
        const { type, pages, onClick } = this.props;
        const paginationTypeDataUat = `superbanner__pager--${type}`;
        return (React.createElement("div", { className: `rj-superbanner__pager rj-superbanner__pager--${type}`, "data-u\u0430t": paginationTypeDataUat }, pages.map(page => (React.createElement(PaginationItem, Object.assign({ key: page.id }, page, { handler: onClick }))))));
    }
};
SuperBannerPagination = __decorate([
    observer
], SuperBannerPagination);
export { SuperBannerPagination };
//# sourceMappingURL=SuperBannerPagination.js.map